import { httpRequest } from "../../http";
import { CoreTarget } from "@models/fieldMap.model";
export class CommandListCoreTargets {
  async run(): Promise<CoreTarget[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/core-targets/`;
    return httpRequest<CoreTarget[]>(url, { method: "GET" });
  }
}
